import * as React from "react";
import SpinkitSpinner from "react-spinkit";
import { blue } from "../constants";

export const Spinner = (props: { fadeIn?: boolean; light?: boolean }) => (
  <SpinkitSpinner fadeIn={props.fadeIn ? undefined : "none"} color={props.light ? "white" : blue} />
);
